Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    box = _STYLES$useStyles.box,
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing,
    colors = _STYLES$useStyles.colors;
  var _smallBp = [bp.mobile_xs, bp.mobile_s, bp.mobile_normal];
  var _borderRadius = (0, _styles.getREM)(1);
  if (bp.mobile_xs) {
    _borderRadius = (0, _styles.getREM)(0.5);
  }
  var _paddingVertical = spacing.xxl;
  var _paddingHorizontal = spacing.l;
  if (bp.is(_smallBp)) {
    _paddingHorizontal = spacing.s;
  }
  var butterfly = {
    position: 'absolute',
    top: -30,
    left: 5,
    width: 67,
    height: 55
  };
  var backgroundImage = {
    width: '100%',
    height: '100%'
  };
  var heading = {
    textAlign: 'center',
    fontSize: _styles.STYLES.fontSize.normal,
    lineHeight: _styles.STYLES.fontSize.m
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    heading.fontSize = _styles.STYLES.fontSize.l;
    heading.lineHeight = _styles.STYLES.lineHeight.l;
  }
  var text = {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    color: colors.footerText
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    text.fontSize = _styles.STYLES.fontSize.normal;
    text.lineHeight = _styles.STYLES.lineHeight.normal;
  }
  var container = Object.assign({}, box, {
    maxWidth: _styles.STYLES.grid.maxBoxWidth,
    width: '100%',
    alignSelf: 'center',
    alignItems: 'center',
    position: 'relative',
    backgroundColor: colors.boxBackground,
    borderRadius: _borderRadius,
    paddingLeft: _paddingHorizontal,
    paddingRight: _paddingHorizontal,
    paddingTop: _paddingVertical,
    paddingBottom: _paddingVertical
  });
  var styles = _reactNative.StyleSheet.create({
    container: container,
    heading: heading,
    textContainer: {
      textAlign: 'center',
      marginBottom: spacing.normal
    },
    text: text,
    butterfly: butterfly,
    backgroundImage: backgroundImage
  });
  return {
    styles: styles
  };
};